import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import DateField from '../../../../../components/forms/DateField';
import { usePrivilege } from '../../../../../components/priviledge/PriviledgeProvider';
import useCompanies from '../../../../../hooks/api-calls/useCompanies';
import { pickupStatuses } from '../../../../../utils/SelectorMapping';
import useVehicles from '../../../../../hooks/api-calls/useVehicles';
import useUsers from '../../../../../hooks/api-calls/useUsers';
import useRoutes from '../../../../../hooks/api-calls/useRoutes';

interface HeadquarterPickupsFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const HeadquarterPickupsFilters: React.FC<HeadquarterPickupsFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getCompaniesList } = useCompanies();
    const { getUsersList } = useUsers();
    const { getVehiclesList } = useVehicles();
    const { getRoutesList } = useRoutes();

    // RENDER 

    return (
        <>
            <CustomSelect
                id="user"
                label="Usuarios"
                placeholder="usuarios"
                options={getUsersList() || []}
                value={filters.filter_filters?.user ? getUsersList()?.filter(user => filters.filter_filters?.user.includes(user.value)) || [] : []}
                onChange={(value: any) => updateFilters({ user: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
                isSearchable={true}
                isLoading={!getUsersList()}
            />

            <CustomSelect
                id={'vehicle'}
                label="Vehiculo"
                placeholder="vehiculos"
                options={getVehiclesList() || []}
                value={filters.filter_filters?.vehicle ? getVehiclesList()?.filter(vehicle => filters.filter_filters?.vehicle.includes(vehicle.value)) || [] : []}
                onChange={(value: any) => updateFilters({ vehicle: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
                isSearchable={true}
                isLoading={!getVehiclesList()}
            />

            <CustomSelect
                id="route"
                label="Ruta"
                placeholder="rutas"
                options={getRoutesList() || []}
                value={filters.filter_filters?.route ? getRoutesList()?.filter(route => filters.filter_filters?.route.includes(route.value)) || [] : []}
                onChange={(value: any) => updateFilters({ route: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
                isSearchable={true}
                isLoading={!getRoutesList()}
            />

            <CustomSelect
                id="pickup_status"
                label="Estado"
                placeholder="estados"
                options={pickupStatuses}
                value={pickupStatuses.filter((item: any) => filters.filter_filters?.pickup_status?.includes(item.value))}
                onChange={(value: any) => updateFilters({ pickup_status: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de recogida"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.pickup_date?.from ? new Date(filters.filter_filters.pickup_date.from) : null}
                endDate={filters.filter_filters?.pickup_date?.to ? new Date(filters.filter_filters.pickup_date.to) : null}
                onChange={(date: any) => {
                    const filters_pickup_date = filters.filter_filters?.pickup_date;
                    const pickup_date = date ? { from: date[0], to: date[1] } : null;

                    if (pickup_date && !isEqual(filters_pickup_date, pickup_date)) {
                        updateFilters({ pickup_date });
                    } else if (!pickup_date && filters_pickup_date) {
                        updateFilters({ pickup_date: null });
                    }
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de actualización"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.updated_at?.from ? new Date(filters.filter_filters.updated_at.from) : null}
                endDate={filters.filter_filters?.updated_at?.to ? new Date(filters.filter_filters.updated_at.to) : null}
                onChange={(date: any) => {
                    const filters_updated_at = filters.filter_filters?.updated_at;
                    const updated_at = date ? { from: date[0], to: date[1] } : null;

                    if (updated_at && !isEqual(filters_updated_at, updated_at)) {
                        updateFilters({ updated_at });
                    } else if (!updated_at && filters_updated_at) {
                        updateFilters({ updated_at: null });
                    }
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de creación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.created_at?.from ? new Date(filters.filter_filters.created_at.from) : null}
                endDate={filters.filter_filters?.created_at?.to ? new Date(filters.filter_filters.created_at.to) : null}
                onChange={(date: any) => {
                    const filters_created_at = filters.filter_filters?.created_at;
                    const created_at = date ? { from: date[0], to: date[1] } : null;

                    if (created_at && !isEqual(filters_created_at, created_at)) {
                        updateFilters({ created_at });
                    } else if (!created_at && filters_created_at) {
                        updateFilters({ created_at: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />
            )}

        </>
    );
};

export default HeadquarterPickupsFilters;